export { default as IndexGallery } from './IndexGallery';



// WEBPACK FOOTER //
// ./src/components/IndexGallery/index.ts